import React from "react";

// Abstract diagrams of the projects' structure, not product screenshots.
export default function ProjectArt({ project }) {
  if (project === "eitri") {
    return (
      <div className="project-art art-eitri" aria-hidden="true">
        <div className="workspace-drawing">
          <div className="drawing-bar">
            <span className="window-dots">
              <i />
              <i />
              <i />
            </span>
            <span>Eitri</span>
            <span className="drawing-cross">+</span>
          </div>
          <div className="drawing-panes">
            <div className="editor-pane">
              <div className="pane-label">Neovim</div>
              <div className="code-drawing">
                {[72, 49, 85, 62, 39, 69].map((width, i) => (
                  <div key={i}>
                    <span>{i + 1}</span>
                    <i style={{ width: `${width}%` }} />
                  </div>
                ))}
              </div>
              <div className="editor-cursor" />
            </div>
            <div className="agent-pane">
              <div className="pane-label">Claude Code</div>
              <div className="agent-symbol">✳</div>
              <i />
              <i />
              <i />
              <div className="agent-input">
                <span />＋
              </div>
            </div>
          </div>
          <div className="terminal-pane">
            <span>Terminal</span>
            <span className="terminal-prompt">
              ❯ <i />
            </span>
          </div>
        </div>
      </div>
    );
  }
  if (project === "skuld") {
    return (
      <div className="project-art art-skuld" aria-hidden="true">
        <div className="sync-orbit orbit-one" />
        <div className="sync-orbit orbit-two" />
        <div className="task-sheet">
          <span className="sheet-title">Skuld</span>
          <div className="task-line checked">
            <span>✓</span>
            <i />
          </div>
          <div className="task-line">
            <span />
            <i />
          </div>
          <div className="task-line">
            <span />
            <i />
          </div>
          <div className="local-label">
            <i /> Available offline
          </div>
        </div>
        <span className="device-label device-web">Web</span>
        <span className="device-label device-mobile">Mobile</span>
        <span className="device-label device-desktop">Desktop</span>
        <span className="device-label device-terminal">Terminal</span>
      </div>
    );
  }
  return (
    <div className="project-art art-draupnir" aria-hidden="true">
      <div className="distribution-lines">
        <span />
        <span />
        <span />
        <span />
      </div>
      <div className="package-hub">
        <svg viewBox="0 0 48 48" width="40" height="40" fill="none">
          <path
            d="m24 4 17 10v20L24 44 7 34V14L24 4Z M7 14l17 10 17-10M24 24v20M16 9l17 10"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </svg>
        <span>draupnir</span>
      </div>
      <span className="package-node node-apt">APT</span>
      <span className="package-node node-pacman">pacman</span>
      <span className="package-node node-fdroid">F-Droid</span>
      <span className="package-node node-nuget">NuGet</span>
    </div>
  );
}
